import { Component, h, Method, Prop, State } from '@stencil/core';
import type { ComponentInterface } from '@stencil/core';

@Component({
	tag: 'app-accordion',
	styleUrl: 'accordion.scss'
})
export class Accordion implements ComponentInterface {
	@Prop() accordionTitle: string;
	@Prop() appIcon: string;
	@Prop() imgSrc: string;
	@Prop() imgAlt: string; 
	@Prop() imgRole: string = 'presentation'
	@Prop({ 
		mutable: true 
	}) accordionId: string;
	@Prop() defaultOpen: boolean = false;
	@State() open: boolean = false;

	componentWillLoad() {
		// If not id is provided, generate one using the accordion title.
		if (!this.accordionId) {
			this.accordionId = this.accordionTitle.replace(/[\s]/gi, '-').replace(/[^A-Z0-9\-]/gi, '');
		}

		// If hash matches this accordion, open on load, or use defaultOpen
		this.open = window.location.hash?.toLowerCase() === `#${this.accordionId.toLowerCase()}` || this.defaultOpen;
	}

	toggleAccordion() {
		/*this.closeOtherAccordions();*/
		this.open = !this.open;
	}

	closeOtherAccordions() {
		const accordions = document.querySelectorAll('app-accordion');

		accordions?.forEach(accordion => {
			if (accordion.accordionId != this.accordionId) {
				accordion.closeAccordion();
			}
		});
	}

	@Method() async closeAccordion() {
		this.open = false;
	}

	render() {
		return (
			<section class="app-accordion">
				<h3>
					<button
						id={this.accordionId}
						class="app-accordion__trigger"
						aria-controls={this.accordionId + "_content"}
						aria-expanded={this.open ? 'true' : 'false'}
						type="button"
						onClick={() => {this.toggleAccordion();}}
					>
						<app-icon icon={this.appIcon} class="card-accordion__icon" slot="icon"></app-icon>
						<img src={this.imgSrc} alt={this.imgAlt} slot="image" />
						{this.accordionTitle}
						<app-icon icon="plus" class="plus"/>
						<app-icon icon="minus" class="minus"/>
					</button>
				</h3>
				<div
					id={this.accordionId + "_content"}
					class="app-accordion__content"
					role="region"
					aria-labelledby={this.accordionId}
					{...(!this.open && {'aria-hidden':'true'})}
				>
					<div class="app-accordion__content-wrapper">
						<slot />
					</div>
				</div>
			</section>
		);
	}
}
